import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { authApiClient } from '../../../utils/axios';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

export const mutateNotificationToBuyerOnDocumentApproval = async ({ payload }) => {
  const { data } = await authApiClient.patch(
    '/organization/settings/notification-tobuyer-on-document-approval',
    payload,
  );

  return data;
};

export const useMutateNotificationToBuyerOnDocumentApprovalHandler = ({ onSuccess, onError }) => {
  const dispatch = useDispatch();
  const { snackbarMessages } = useTranslatedMessages();

  const settingsMessages = snackbarMessages.settings ?? {};
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: mutateNotificationToBuyerOnDocumentApproval,

    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['org'],
      });

      dispatch(
        showSnackbar({
          message: settingsMessages.organization_settings_updated_success,
          severity: 'success',
        }),
      );

      if (onSuccess) {
        onSuccess(variables);
      }
    },

    onError: (error) => {
      dispatch(
        showSnackbar({
          message: 'Failed to update notification settings. Please try again.',
          severity: 'error',
        }),
      );

      if (onError) {
        onError(error);
      }
    },
  });

  const onSubmit = async (payload) => {
    return mutation.mutateAsync({ payload });
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: mutation.error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit,
  };
};
